const PLUGIN_NAME = 'local-example-plugin';

export { PLUGIN_NAME };
